import { render, staticRenderFns } from "./ViewAbsencePage.vue?vue&type=template&id=839d2b06&scoped=true&"
import script from "./ViewAbsencePage.vue?vue&type=script&lang=js&"
export * from "./ViewAbsencePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewAbsencePage.vue?vue&type=style&index=0&id=839d2b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839d2b06",
  null
  
)

export default component.exports